// extracted by mini-css-extract-plugin
export default {"button-mobile":"FullscreenButton_button-mobile__k9PK2"};